import React from "react";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const buildCountdownText = (deactivateDate) => {
  const closesAt = dayjs.utc(deactivateDate).local();
  const now = dayjs();

  if (!closesAt.isValid()) return null;
  if (!closesAt.isAfter(now)) return "Survey Closed";

  const totalHours = closesAt.diff(now, "hour");
  const weeks = Math.floor(totalHours / 168);
  const days = Math.floor((totalHours % 168) / 24);
  const hours = totalHours % 24;

  const parts = [];
  if (weeks > 0) parts.push(`${weeks} ${weeks === 1 ? "week" : "weeks"}`);
  if (days > 0) parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);

  if (parts.length === 0) return "Survey Closing in less than 1 hour";

  return `Survey Closing in ${parts.join(" ")}`;
};

const SurveyCloseCountdown = () => {
  const displayCloseMsg = useSelector(
    (state) => state.survey.activeSurveys[0]?.displayCloseMsg
  );
  const deactivateDate = useSelector(
    (state) => state.survey.activeSurveys[0]?.deactivateDate
  );

  if (!displayCloseMsg || !deactivateDate) return null;

  const countdownText = buildCountdownText(deactivateDate);

  if (!countdownText) return null;

  return (
    <Typography color="error" fontWeight="bold" marginTop={1}>
      {countdownText}
    </Typography>
  );
};

export default SurveyCloseCountdown;
